import { Eye, EyeOff } from 'lucide-react';
import { type ComponentProps, useState } from 'react';

import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

// A password/secret field with a reveal toggle. `type` is owned by the toggle, so
// it's omitted from the passthrough props.
export function PasswordInput({
  className,
  disabled,
  ...props
}: Omit<ComponentProps<'input'>, 'type'>) {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className="relative">
      <Input
        type={revealed ? 'text' : 'password'}
        className={cn('pr-9', className)}
        disabled={disabled}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        disabled={disabled}
        onClick={() => setRevealed((prev) => !prev)}
        aria-label={revealed ? 'Hide' : 'Show'}
        aria-pressed={revealed}
        className={cn(
          'absolute inset-y-0 right-0 flex w-9 items-center justify-center rounded-r-md text-[var(--color-muted-foreground)] transition-colors',
          'hover:text-[var(--color-foreground)] outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-ring)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
        )}
      >
        {revealed ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  );
}
